import React from "react";

const MAP = {
  "BELUM CHECK-IN": "bg-slate-100 text-slate-600 border-slate-200",
  "SEDANG BEKERJA": "bg-sky-50 text-[#284f7a] border-sky-200",
  "SUDAH CHECK-OUT": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "PERLU REVIEW": "bg-purple-50 text-purple-700 border-purple-200",
  "TEPAT WAKTU": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "TERLAMBAT": "bg-amber-50 text-amber-700 border-amber-200",
  "NORMAL": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "PULANG LEBIH AWAL": "bg-amber-50 text-amber-700 border-amber-200",
  "INSIDE RADIUS": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "OUTSIDE RADIUS": "bg-rose-50 text-rose-700 border-rose-200",
  "LOW ACCURACY": "bg-rose-50 text-rose-700 border-rose-200",
  "PENDING": "bg-slate-100 text-slate-600 border-slate-200",
  "DISETUJUI": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "DITOLAK": "bg-rose-50 text-rose-700 border-rose-200",
  "aktif": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "nonaktif": "bg-slate-100 text-slate-500 border-slate-200",
};

export default function StatusBadge({ status, testid }) {
  if (!status) return <span className="text-slate-400">-</span>;
  const cls = MAP[status] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}>
      {status}
    </span>
  );
}
